import { render, staticRenderFns } from "./bindPromotionQRLabel.vue?vue&type=template&id=4c48aa62&scoped=true&"
import script from "./bindPromotionQRLabel.vue?vue&type=script&lang=js&"
export * from "./bindPromotionQRLabel.vue?vue&type=script&lang=js&"
import style0 from "./bindPromotionQRLabel.vue?vue&type=style&index=0&id=4c48aa62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c48aa62",
  null
  
)

export default component.exports